// Helper function to format UTC dates to local timezone
export const formatDateTime = (utcDateString: string): string => {
  const date = new Date(utcDateString);
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

// Langfuse trace URL builder
const LANGFUSE_PROJECT_ID = "cmdqypzy30494ad07fae27ba0";
export const getLangfuseTraceUrl = (traceId: string): string =>
  `https://cloud.langfuse.com/project/${LANGFUSE_PROJECT_ID}/traces/${traceId}`;

export const getScoreColorClasses = (score: number) => {
  if (score >= 4) {
    return {
      badge: "!al-bg-green-100 !al-text-green-700 al-border al-border-green-200",
      text: "al-text-green-700",
      bg: "al-bg-green-50 al-border-green-200",
    };
  } else if (score >= 3) {
    return {
      badge: "!al-bg-yellow-100 !al-text-yellow-700 al-border al-border-yellow-200",
      text: "al-text-yellow-700",
      bg: "al-bg-yellow-50 al-border-yellow-200",
    };
  } else {
    return {
      badge: "!al-bg-red-100 !al-text-red-700 al-border al-border-red-200",
      text: "al-text-red-700",
      bg: "al-bg-red-50 al-border-red-200",
    };
  }
};

export const getValidModel = (model: string | undefined, availableModels?: string[]) => {
  if (!model || !availableModels?.includes(model)) {
    return "sonnet";
  }
  return model;
};
